import { create } from 'zustand';

type ModalOption =
  | 'cancel-confirm'
  | 'canceled'
  | 'cancelation-policy'
  | 'withdraw-offer'
  | 'cancel-booking'
  | 'transfer-option'
  | 'contact-support'
  | 'date-filter'
  | 'specialties-filter'
  | 'languages-filter'
  | 'all-local-search-filters'
  | null;

type ModalState = {
  modal: ModalOption;
  setModal: (modal: ModalOption) => void;
};
export const useModalStore = create<ModalState>()((set) => ({
  modal: null,
  setModal: (modal) => set({ modal }),
}));
